import { CSSResultArray, html, TemplateResult, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BeaconPopover } from '@trp-beacon-ui-kit/foundation/components/beacon-popover';
import style from './product-center-popover.scss?inline';
import { Constants } from './product-center-popover.constants';
import { IconSVG } from '../../../../common/utils/icon';

/**
 * @tag pop-product-center-popover
 */
@customElement(Constants.TAG_NAME)
export class PopProductCenterPopover extends BeaconPopover {
  static get styles(): CSSResultArray {
    const parentStyles = super.styles;
    // Return the combined styles
    return [parentStyles, unsafeCSS(style)];
  }

  protected renderArrow(): TemplateResult {
    return html`<div class="literature-arrow-spacer">
      ${IconSVG.popoverArrow()}
    </div>`;
  }

  protected renderOverlayWrapper(): TemplateResult {
    return html`<div
      id="${super.overlayName}"
      class="overlay-wrapper  ${super.placement}"
    >
      ${this.renderContentWrapper()}
    </div>`;
  }

  protected renderPredictiveSearchOverlayWrapper(): TemplateResult {
    return html`<div
      id="${super.overlayName}"
      class="overlay-wrapper predictive-search-overlay-wrapper ${super.placement} style="width: 100%;"
    >
      ${this.renderContentWrapper()}
    </div>`;
  }

  /**
   * Render template: adjusts content wrapper
   */
  renderContentWrapper(): TemplateResult {
    return html`<div class="beacon-popover-surface">
      ${this.renderArrow()}}
      <div
        class="beacon-popover-zones-wrapper"
        aria-live="${super.open ? 'polite' : 'off'}"
      >
        ${super.renderOverlayContent()}
      </div>
    </div>`;
  }

  protected handleExternalClick = (event: Event) => {
    if (event.isTrusted) {
      const composedPath = event.composedPath();
      if (!composedPath.includes(super.overlayEl) && super.open) {
        super.close();

        const beaconButton = this.querySelector('beacon-button');
        const nativeButton = beaconButton?.shadowRoot.querySelector('button');
        nativeButton?.setAttribute('aria-expanded', 'false');
      }
    }
  };
}
